import type { CSSProperties, ComputedRef, InjectionKey, Ref } from 'vue'
import type { UseNamespaceReturn } from '@pit-element-plus/hooks'

export type DialogHeaderContext = {
  dialogRef: Ref<HTMLElement | undefined>
  headerRef: Ref<HTMLElement | undefined>
  bodyId: Ref<string>
  ns: UseNamespaceReturn
  rendered: Ref<boolean>
  style: ComputedRef<CSSProperties>
}

export const dialogHeaderInjectionKey: InjectionKey<DialogHeaderContext> =
  Symbol('dialogHeaderInjectionKey')
